import React, { useState } from 'react'
import { useDispatch } from 'react-redux';

import { 
    Grid,
    Paper, 
    Button,
    makeStyles,
    Chip,
    Typography
} from "@material-ui/core";

import Buscador from '../../../actions/ui/Buscador'
import { startAlerta } from '../../../actions/ui/alertas';

const buttonStyle = {
    textAlign: 'center'
}

const useStyles = makeStyles((theme) => ({
    chip: {
      margin: theme.spacing(0.5),
    },
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      margin: "0.5em 0 0",
    },
  }));

export const EmpadronamientoDiagnosticosForm = ({formValues, setearValor, idSolicitud}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [diagnostico, setDiagnostico] = useState(null);

    const insertValue = () => {
        if(formValues.diagnosticos?.length < 10){
            if(diagnostico !== null){
                const existeDiagnostico = formValues.diagnosticos.find(item => item.idDiagnostico === diagnostico.idProblema);
                if (!existeDiagnostico){

                    var newDiagnostico = {
                        diagnostico: diagnostico,
                        idSolicitud: idSolicitud,
                        idDiagnostico: diagnostico.idProblema
                    };

                    setearValor("diagnosticos", [
                        ...formValues.diagnosticos,
                        newDiagnostico
                    ]);
                }else{
                    dispatch(startAlerta(
                        "Ya se cargo este diagnostico",
                        "warning"
                    ));
                }
                setDiagnostico(null);
            }
        }else{
            dispatch(startAlerta(
                "Solo puede ingresar máximo 10 diagnósticos",
                "warning"
            ));
        }
    }

    return (
        <Paper style={{padding: "1em"}}>
            <Grid container spacing={1} justify='center' alignItems='center'>
                <Grid item xs={12} md={4}>
                    <Paper elevation={2} style={{padding: "1em"}}>
                        <Grid container direction='column' spacing={2}>
                            <Grid item xs={12}>
                                <Buscador 
                                    value={diagnostico} 
                                    setValue={(val) => setDiagnostico(val)}
                                    label="Diagnostico" 
                                    endpoint={(param) => `Diagnosticos/buscar?texto=${param}`}
                                    noOptionText={"No se encuentran diagnosticos"}
                                    getOptionLabel={(option) => `${option.problema}`}
                                />
                            </Grid>
                            <Grid item xs={12} style={buttonStyle}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={insertValue}
                                >
                                    + AGREGAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={8} style={{display: "flex", flexDirection: "column",justifyContent: "center", alignItems: "center",textAlign: "center", margin: "0.5em 0 0"}}>
                    <Typography variant="button">Diagnósticos agregados</Typography>
                    <div className={classes.root}>
                        {formValues.diagnosticos?.length > 0 ? (
                                formValues.diagnosticos.map((diagnostico, index) => (
                                    <Chip
                                        key={index}
                                        label={`${diagnostico.diagnostico.problema}`}
                                        onDelete={() => setearValor(
                                            "diagnosticos",
                                            formValues.diagnosticos.filter(e => e.diagnostico.idProblema !== diagnostico.idDiagnostico)
                                        )}
                                        className={classes.chip}
                                    />
                                ))
                            ) : (
                                <Typography style={{color: "#777", fontWeight: "lighter"}}>No se agregaron diagnosticos</Typography>
                            )
                        }
                    </div>
                </Grid>
            </Grid>
        </Paper>
    )
}
